module.exports = __webpack_public_path__ + "static/media/stack-icon-white.1b0c14cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stack-icon-white.svg
// module id = 1020
// module chunks = 0